import React from 'react'

const TodosError = () => {
  return (
    <div>Ups! We have an error here</div>
  )
}

export {TodosError}